import fetchTopicTree from './action-topic-list';
import { fetchArticle } from '../../contactUs/actions/action-article';
import { resetRelatedArticle } from '../../contactUs/actions/action-related-article';
import { updateBreadCrumbFromArticleContent } from './action-breadcrumb';
import getCommunityResults from './action-community-posts';
import getOpenCase from '../actions/action-case-checker';
import * as Page from '../../lib/page';
import { displayChatBot } from './action-chat-bot';
import fireTrackEventWhenFptiIsReady from '../../lib/fpitEvents';

export default function fetchArticleContent(experience, faqid) {
  return (dispatch, getState) => {
    dispatch(resetRelatedArticle());
    const { topicList } = getState();
    if (topicList && topicList.topics && topicList.topics.length <= 0) {
      dispatch(fetchTopicTree(experience));
    }
    dispatch(fetchArticle(faqid, true))
      .then((response) => {
        if (response && response.payload) {
          fireTrackEventWhenFptiIsReady({ id: 'articlePage', link: `smarthelp-article|${faqid}`, hpid: faqid }); // FPTI impression event for receiving article content
          dispatch(updateBreadCrumbFromArticleContent(response.payload));
          dispatch(getCommunityResults({ title: response.payload.articleTitle, id: faqid }));
          if (Page.isLoggedIn() && Page.isDisputeArticle(response.payload.articleTitle)) {
            dispatch(getOpenCase());
          }
        } else {
          fireTrackEventWhenFptiIsReady({ id: 'articleErrorPage', link: `smarthelp-error-article|${faqid}`, hpid: faqid });
        }
        dispatch(displayChatBot());
      })
      .catch(() => {});
  };
}
